import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_249: DocMigration = {
  maxSchemaVersion: "0.0.249",
  description: "Convert casework widthMode to type and rename existing params for upgrade",
  apply(json: any) {
    for (const caseworkId in json.casework) {
      const casework = json.casework[caseworkId];

      // change prop names
      // flipEdge to paramFromEnd
      if (casework.flipEdge !== undefined) {
        casework.paramFromEnd = casework.flipEdge;
        delete casework.flipEdge;
      }

      // baseHeight to verticalOffset
      if (casework.baseHeight !== undefined) {
        casework.verticalOffset = casework.baseHeight;
        delete casework.baseHeight;
      }

      // offset to lateralOffset
      if (casework.offset !== undefined) {
        casework.lateralOffset = casework.offset;
        delete casework.offset;
      }

      // fixedWidth to width
      if (casework.fixedWidth !== undefined) {
        casework.width = casework.fixedWidth;
        delete casework.fixedWidth;
      }

      const { edgeIds } = casework;

      // convert multi-edge FIXED width mode casework to DYNAMIC
      if (edgeIds && (casework.catalogDescriptorId !== undefined || casework.widthMode === "FIXED")) {
        if (edgeIds.length > 1) {
          // this doesn't account for normalized paramStart values since edge length is not known, but
          // it passes regression tests
          casework.paramEnd = casework.width + casework.paramStart;
          casework.paramEndNormalized = false;
          casework.type === "DYNAMIC";
          delete casework.widthMode;
        } else if (edgeIds.length === 1) {
          // single edge casework
          casework.edgeId = edgeIds[0];
          delete casework.edgeIds;
        }
      }

      const placementStart = {} as any;

      // move param props into objects
      if (casework.paramStart !== undefined) {
        placementStart.param = casework.paramStart;
        delete casework.paramStart;
      }

      if (casework.paramStartNormalized !== undefined) {
        placementStart.paramNormalized = casework.paramStartNormalized;
        delete casework.paramStartNormalized;
      }

      if (Object.keys(placementStart).length > 0) {
        casework.placementStart = placementStart;
      }

      const placementEnd = {} as any;

      if (casework.paramEnd !== undefined) {
        placementEnd.param = casework.paramEnd;
        delete casework.paramEnd;
      }

      if (casework.paramEndNormalized !== undefined) {
        placementEnd.paramNormalized = casework.paramEndNormalized;
        delete casework.paramEndNormalized;
      }

      if (Object.keys(placementEnd).length > 0) {
        casework.placementEnd = placementEnd;
      }

      // widthMode to type
      if (casework.catalogDescriptorId !== undefined || casework.widthMode === "FIXED") {
        casework.type = "FIXED";
      } else if (casework.widthMode === "DYNAMIC") {
        casework.type = "DYNAMIC";
      }
      delete casework.widthMode;
    }
    return json;
  },
};

export default migration_0_0_249;
